import { memo } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";

const ACCENTS = [
	{ accent: "#eef8ff", border: "#bfdbfe" },
	{ accent: "#f1fdf5", border: "#bbf7d0" },
	{ accent: "#fff8ef", border: "#fde68a" },
	{ accent: "#fff5f5", border: "#fecaca" },
	{ accent: "#f8fbff", border: "#dbeafe" },
];

const formatAverage = (value) => {
	if (value == null || Number.isNaN(value)) return "-";
	return `${Number(value).toFixed(1)} / 5`;
};

const ProgressAverages = ({ analytics }) => {
	if (!analytics) return null;

	const averages = analytics.averages ?? [];

	return (
		<div className="mb-4">
			<div className="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-2 mb-3">
				<div>
					<h6 className="mb-1 fw-semibold">Ringkasan Private Session Progress</h6>
					<small className="text-muted">
						Rata-rata jawaban skala 1–5 per pertanyaan dari sesi private yang sudah checkout.
					</small>
				</div>
				<div className="rounded-pill border px-3 py-2 small text-muted bg-white">
					{analytics.totalSessions ?? 0} sesi
				</div>
			</div>

			<Row className="g-3 mb-3">
				<Col xs="12" md="4" lg="3">
					<Card
						className="h-100 border-0 rounded-4"
						style={{
							border: "1px solid #dbeafe",
							boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
						}}
					>
						<CardBody
							className="p-3"
							style={{
								background: "linear-gradient(135deg, #f8fbff 0%, #ffffff 100%)",
							}}
						>
							<div className="h4 mb-1 fw-bold text-dark">
								{analytics.totalSessions ?? 0}
							</div>
							<small className="text-muted d-block">Total Sesi</small>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<Row className="g-3">
				{averages.map((item, index) => {
					const style = ACCENTS[index % ACCENTS.length];
					return (
						<Col xs="12" md="6" xl="4" key={item.code}>
							<Card
								className="h-100 border-0 rounded-4"
								style={{
									border: `1px solid ${style.border}`,
									boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
								}}
							>
								<CardBody
									className="p-3"
									style={{
										background: `linear-gradient(135deg, ${style.accent} 0%, #ffffff 100%)`,
									}}
								>
									<div className="d-flex justify-content-between align-items-start gap-2 mb-2">
										<small className="text-muted text-uppercase fw-semibold">
											{String(item.code).replace("progress_", "").toUpperCase()}
										</small>
										<span className="fw-bold text-dark">
											{formatAverage(item.average)}
										</span>
									</div>
									<div className="small text-dark" style={{ lineHeight: 1.45 }}>
										{item.title}
									</div>
								</CardBody>
							</Card>
						</Col>
					);
				})}
			</Row>
		</div>
	);
};

export default memo(ProgressAverages);
